import { IssueStatus, SEVERITY_LABELS } from '@momentum/types';

interface SeverityStyle {
  labelKey: string;
  color: string;
}
interface StatusStyle {
  labelKey: string;
  color: string;
  bg: string;
}

export const SEVERITY_CONFIG: Record<number, SeverityStyle> = {
  [SEVERITY_LABELS.Low]: { labelKey: 'severityLow', color: '#22c55e' },
  [SEVERITY_LABELS.Medium]: {
    labelKey: 'severityMedium',
    color: '#eab308',
  },
  [SEVERITY_LABELS.High]: { labelKey: 'severityHigh', color: '#f97316' },
  [SEVERITY_LABELS.Critical]: {
    labelKey: 'severityCritical',
    color: '#ef4444',
  },
};

export const STATUS_CONFIG: Record<string, StatusStyle> = {
  [IssueStatus.TODO]: {
    labelKey: 'statusTodo',
    color: '#64748b',
    bg: '#f1f5f9',
  },
  [IssueStatus.IN_PROGRESS]: {
    labelKey: 'statusInProgress',
    color: '#2563eb',
    bg: '#eff6ff',
  },
  [IssueStatus.COMPLETED]: {
    labelKey: 'statusDone',
    color: '#16a34a',
    bg: '#f0fdf4',
  },
};
